import { Component, OnInit, OnDestroy, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CoreConfigService } from "@core/services/config.service";

@Component({
  selector: "app-reset-password-redirect",
  templateUrl: "./reset-password-redirect.component.html",
  styleUrls: ["./reset-password-redirect.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ResetPasswordRedirectComponent implements OnInit, OnDestroy {
  token: string = "";
  public coreConfig: any;
  showFallback: boolean = false;
  private fallbackTimeout: any;

  constructor(private route: ActivatedRoute, private _coreConfigService: CoreConfigService) {
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  ngOnInit(): void {
    this._coreConfigService.config.subscribe((config) => {
      this.coreConfig = config;
    });

    this.token = this.route.snapshot.queryParamMap.get("token") || "";
    if (this.token) {
      this.redirectToApp();
    }
  }

  ngOnDestroy(): void {
    if (this.fallbackTimeout) {
      clearTimeout(this.fallbackTimeout);
    }
  }

  redirectToApp(): void {
    const deepLink = `utrav://reset-password?token=${this.token}`;

    // Redirection immédiate vers le deep link
    window.location.href = deepLink;

    // Afficher les options de fallback après 2 secondes si l'app ne s'ouvre pas
    this.fallbackTimeout = setTimeout(() => {
      this.showFallback = true;
    }, 2000);
  }

  openAppStore(): void {
    window.location.href = "https://apps.apple.com/app/utrav/6756850786";
  }

  openPlayStore(): void {
    window.location.href = "https://play.google.com/store/apps/details?id=com.utrav.app";
  }
}
